<div class="flex justify-between items-center pr-2">
  <h2 mat-dialog-title>{{data.title | translate: data.locale | async}} {{'Help' | translate: data.locale | async}}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div [innerHTML]="content$ | async"></div>
</mat-dialog-content>
